import { render, staticRenderFns } from "./NpiSearchPage.vue?vue&type=template&id=2f50c026&"
import script from "./NpiSearchPage.vue?vue&type=script&lang=js&"
export * from "./NpiSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports